"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GalleryHeader = void 0;

var _styles = require("./styles");

var _CheckBox = require("../../atoms/CheckBox");

var _jsxRuntime = require("react/jsx-runtime");

var GalleryHeader = function GalleryHeader(_ref) {
  var setCheckAll = _ref.setCheckAll,
      setSelectedImages = _ref.setSelectedImages,
      shotThd = _ref.shotThd;

  var checkAll = function checkAll(e) {
    var checkboxList = document.querySelectorAll("[id^='gallery-element-']");
    checkboxList.forEach(function (chk) {
      return chk.checked = e.target.checked;
    });
    setCheckAll(e.target.checked);
    if (!e.target.checked) setSelectedImages([]);
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckBox.CheckBox, {
        id: "check-all-images",
        onChange: function onChange(e) {
          return checkAll(e);
        }
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "image-header",
      children: "Imagen"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "image-name",
      children: "Nombre"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "image-size",
      children: "Tama\xF1o"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "image-format",
      children: "Formato"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "image-description",
      children: "\xBFTiene leyenda?"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "",
      children: "Tipo de toma"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "",
      children: "Tipo de imagen"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "",
      children: "Tipo de empaque"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "",
      children: "Estatus"
    })]
  });
};

exports.GalleryHeader = GalleryHeader;